import { FormItem } from 'module/ui/components/atoms/choices/add-option';
import { BaseFieldContent } from 'module/ui/components/atoms/choices/list';
import { FieldsWrapper } from 'module/ui/components/atoms/choices/list';
import styled from 'styled-components';

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-01);
`;

export const CheckboxDescription = styled.div`
  font-size: var(--font-size-md);
  padding-left: var(--spacing-06);
  color: var(--text-tertiary);
`;

export const ChoicesWrapper = styled.div`
  margin-top: var(--spacing-05);
  display: flex;
  gap: var(--spacing-03);
  flex-wrap: wrap;
`;

export const AiGeneratedChoices = styled.div`
  margin-top: var(--spacing-03);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-01);
`;
export const ChoicesContainer = styled.div`
  gap: var(--spacing-02);
  display: flex;
  flex-direction: column;

  ${BaseFieldContent} {
    background-color: var(--white-100);
    margin-right: var(--spacing-03);
  }

  ${FormItem} {
    margin-bottom: 0;
    padding-bottom: var(--spacing-01) !important;
  }

  ${FieldsWrapper} {
    gap: var(--spacing-02);
  }
  .ant-form .ant-form-item-control-input {
    margin-bottom: 0;
  }

  .ant-btn {
    margin-left: var(--spacing-03);
  }
`;
